'use client';
import { createContext, useContext } from 'react';
const FORK_COMMAND_RE = /^\/fork(?:\s+|$)([\s\S]*)$/i;
/** Returns the text after a typed `/fork` command, or null when the query isn't one. */
export function parseForkCommand(query) {
    const match = FORK_COMMAND_RE.exec(query ?? '');
    return match ? (match[1]?.trim() ?? '') : null;
}
export function getThreadForkParams({ branchMode, isReadOnly, newFrontendContextUUID, existingFrontendContextUUID, }) {
    const fork = isReadOnly || branchMode != null;
    return {
        fork,
        branchMode: branchMode ?? undefined,
        lastBackendUUIDOverride: branchMode?.sourceEntryUUID,
        newFrontendContextUUID: fork ? newFrontendContextUUID : null,
        existingFrontendContextUUID: fork ? undefined : existingFrontendContextUUID,
    };
}
const NOOP_BRANCH_MODE = {
    branchMode: null,
    startBranchMode: () => { },
    cancelBranchMode: () => { },
};
export const BranchModeContext = createContext(null);
export const useBranchMode = () => {
    return useContext(BranchModeContext) ?? NOOP_BRANCH_MODE;
};
/** Starts a fork of the composer's thread from its latest entry; null where /fork is unavailable. */
export const ForkCommandContext = createContext(null);
//# sourceMappingURL=BranchModeProviderShared.js.map